import { useDispatch } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { RxCross2 } from 'react-icons/rx';

import { CustomLoader } from '../../../services/Reducer';
import apiClient from '../../../api/apiClient';
import authServices from '../../../services/AuthServices';
import { Autocomplete, TextField } from '@mui/material';



const Add_table = ({ show, toggle, refreshData, AddcurrentPage }) => {

  const token = authServices.getToken();

  const [data, setData] = useState([]);
  const fetchCommodities = async () => {
    try {
      const response = await apiClient.get(`/api/admin/commodity/getAll`,
        {
          params: {
            pageNumber: 0,
            pageSize: 200
          },
          headers: {
            'access_token': token,
          }
        }
      );
      setData(response.data.data.records);

    } catch (err) {
      console.error('Error fetching data:', err);
    }
  };

  const filteredData = Array.from(
    new Map(data.map((item) => [item.commodity, item])).values()
  );

  const validData = filteredData.filter((item) => item.commodity);


  const [formData, setFormData] = useState({

    subCommodity: '',
    commodityId: null,

  });
  const [errors, setErrors] = useState({}); // Error state
  const dispatch = useDispatch();

  const loader = (display) => {
    dispatch(CustomLoader(display));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    // Clear the error for the field being edited
    setErrors({ ...errors, [name]: '' });
  };

  const validateForm = () => {
    let formErrors = {};

    if (formData.subCommodity === '') {
      formErrors.subCommodity = 'subCommodity cannot be empty';
    }
    if (formData.commodityId === null) {
      formErrors.commodityId = 'commodityId cannot be empty';
    }


    setErrors(formErrors);
    return Object.keys(formErrors).length === 0; // No errors
  };
  

  const handleSubmit = async (e) => {
    // e.preventDefault();
    if (!validateForm()) {
      return; // Stop submission if there are validation errors
    }

    loader('enable');

    try {

      const response = await apiClient.post('/api/admin/sub_commodity/add', formData, {

        headers: {
          'access_token': token,
        },

      });

      if (response.data.Status === "SUCCESS") {
        setFormData({
          subCommodity: '',
          commodityId: null,


        });
      }
      else {
        console.log(response.data.message)
      }
    }
    catch (error) {
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    }
    finally {
      refreshData(AddcurrentPage);
      loader('disable');
      toggle(); // Close the modal after submission
      // window.location.reload();
    }
  };

  useEffect(() => {
    fetchCommodities()
  }, [])
  return (
    <>
      {show && (
        <>
          <div className="modal fade show d-block" id="exampleModalScrollable" tabIndex={-1} role="dialog" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true">
            <div className="modal-dialog modal-dialog-scrollable">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalScrollableTitle">Add Sub_Commodity</h5>
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={toggle} >< RxCross2 /></button>
                </div>
                <div className="modal-body-custom">
                  <form >

                    

                    <div className="spacing" >
                      <label htmlFor="commodityId" className="label-custom">CommodityId</label>
                      {/* <input
                        type="number"
                        className={`input-custom ${errors.commodityId ? 'input-error' : ''}`}
                        id="commodityId"
                        name="commodityId"
                        value={formData.commodityId}
                        onChange={handleChange}
                      />
                     */}

                      <Autocomplete
                        className={` ${errors.commodity ? 'input-error' : ''}`}
                        disablePortal
                        options={validData} // Full user object
                        getOptionLabel={(option) => option.commodity} // Show 'name' in dropdown
                        getOptionSelected={(option, value) => option.id === value.id} // Ensure unique selection
                        renderInput={(params) => <TextField {...params} label="" />}
                        onChange={(event, value) => {
                          if (value) {
                            setFormData({ ...formData, commodity: value.id }); // Save 'id' in state
                          } else {
                            setFormData({ ...formData, commodity: "" }); // Reset state 
                          }
                        }}
                        // Key attribute setup using 'id'
                        renderOption={(props, option) => (
                          <li {...props} key={option.id}>
                            {option.commodity}
                          </li>
                        )}
                        componentsProps={{
                          paper: {
                            style: {
                              maxHeight: '110px', // Dropdown ki maximum height
                              overflowY: 'auto',  // Scroll enable karega
                            },
                          },
                        }}
                      />
                    </div>

                    <div className="spacing" style={{ marginTop: '-1vw' }}>
                      <label htmlFor="subCommodity" className="label-custom">Sub Commodity</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.subCommodity ? 'input-error' : ''}`}
                        id="subCommodity"
                        name="subCommodity"
                        value={formData.subCommodity}
                        onChange={handleChange}
                      />
                    </div>

                  </form>
                </div>

                <div className="modal-footer">

                  <button type="button" style={{ backgroundColor: '#F0F0F0', color: '#000', fontWeight: '500', border: "1px solid #d7dde2" }} className="btn " data-bs-dismiss="modal" onClick={toggle}>
                    Close
                  </button>
                  <button type="button" style={{ color: 'white', fontWeight: '500' }} className="btn btn-primary" onClick={handleSubmit}>
                    Submit
                  </button>

                </div>
              </div>
              {/* /.modal-content */}
            </div>
            {/* /.modal-dialog */}
          </div>
          {/* /.modal */}
        </>
      )}
    </>
  );
};

export default Add_table;
